<template>
    <TransitionRoot as="template" :show="showing">
        <Dialog as="div" class="fixed z-50 inset-0 overflow-y-auto" @close="emit('close')">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                        <div>
                            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100">
                                <MagnifyingGlassCircleIcon class="h-6 w-6 text-gray-600" aria-hidden="true" />
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">Subscription Enablements</DialogTitle>
                                <div class="mt-4">
                                    <ul v-for="enablement in enablements">
                                        <li class="flex justify-center">
                                            <div class="mr-2 font-bold w-1/5 text-sm text-center">
                                                <span class="text-center" v-if="enablementProperties[enablement.permission]?.type === Boolean">
                                                    <CheckIcon class="text-green-400 h-4 w-4 mt-1 mx-auto" v-if="enablement.value === 1" />
                                                    <XMarkIcon class="text-red-400 h-4 w-4 mt-1 mx-auto" v-else />
                                                </span>
                                                <span class="text-center" v-else>
                                                    <template v-if="enablement.value < 0">
                                                        &infin;
                                                    </template>
                                                    <template v-else>
                                                        {{ enablement.value }}
                                                    </template>
                                                </span>
                                            </div>
                                            <div class="capitalize font-light w-3/5 text-left">{{ formatPermission(enablement.permission) }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm" @click="emit('close')">Return</button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import {ref, onMounted, toRef} from "vue"
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue"
import {CheckIcon, MagnifyingGlassCircleIcon, XMarkIcon} from "@heroicons/vue/24/outline"

const enablementProperties = {
    'media-requests': {
        type: Boolean,
    },
    'media-lists': {
        type: Number,
    },
    'user-accounts': {
        type: Number,
    },
    'press-releases': {
        type: Number,
    },
    'profiles': {
        type: Number,
    },
    'copywriting': {
        type: Number,
    },
    'image-attachments': {
        type: Number,
    },
    'detailed-analytics': {
        type: Boolean,
    },
    'historical-publication': {
        type: Boolean,
    },
    'media-database': {
        type: Boolean,
    },
    'custom-press-room': {
        type: Boolean,
    }
}

export default {
    name: "Enablements",
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        MagnifyingGlassCircleIcon,
        CheckIcon,
        XMarkIcon,
    },
    emits: [
        'close'
    ],
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        enablements: {
            type: Object,
            required: true,
        }
    },
    setup(props, { emit }) {
        const showing = toRef(props, 'open')
        const enablements = toRef(props, 'enablements');

        const formatPermission = (permission) => {
            return permission.split('-').join(' ')
        }

        return {
            emit,
            showing,
            enablements,
            formatPermission,
            enablementProperties,
        }
    }
}
</script>

<style scoped>

</style>
